/* eslint-disable @typescript-eslint/naming-convention */

export class AudioTrack<T> {
  isProvided = false;
  isMuted = false;
  isTrackAttached = false;
  isLocalUserSubscribed = null;
  trackPublication: T = null;
  domElement: HTMLMediaElement = null;
  deviceId: string;
  voiceLevel = 0.5;
}

export class VideoTrack<T> {
  isProvided = false;
  isMuted = false;
  trackPublication: T = null;
  isTrackAttached = false;
  mediaWrapper: HTMLElement | null = null;
  deviceId: string;
}

export enum TrackKind {
  AUDIO = 'audio',
  VIDEO = 'video',
  DATA = 'data',
}
